import store, { State } from '@/store';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getValueByPath } from 'yellowfin-ui-lib';
import { CartItem, Product, ProductMedia, Taxonomy } from 'yf-commerce-model-ui-lib';

@Component
export default class BasePicture extends Vue {

    @Prop({ required: false }) opaque?: string;
    @Prop({ required: false }) eid?: number;
    @Prop({ required: false }) placeholder?: string;
    @Prop({ required: false, default: '' }) alt?: string;
    @Prop({ required: false }) imgClass?: string | object | string[];
    @Prop({ required: false }) folder?: string;
    @Prop({ required: false, default: 'md' }) size?: string;
    @Prop({ required: false }) product?: Product;
    @Prop({ required: false }) taxonomy?: Taxonomy;
    @Prop({ required: false }) media?: ProductMedia;
    @Prop({ required: false }) cartItem?: CartItem;
    @Prop({ required: false }) field?: string;
    @Prop({ required: false }) usecdn?: boolean;

    contentready: boolean = false;

    newEid?: number;
    newFolder?: string;
    newOpaque?: string;
    newAlt?: string;
    newUsecdn?: boolean;
    imageready: boolean = false;

    state!: State;

    constructor() {
        super();
        this.state = store;
    }

    get cdn(): boolean {
        if (!this.state.shopConf) return false;
        return this.state.shopConf!.cdn;
    }

    get cdnurl(): string {
        return process.env.VUE_APP_CDN_URL as string;
    }

    get base(): string {
        if (!this.state.shopConf) return '';
        return this.state.shopConf!.cdnfolder;
    }

    beforeMount() {
        this.setContent();
    }

    callready(event: any, type: string) {
        if (!this.imageready) {
            this.imageready = true
            this.$emit('ready', { event, type });
        }
    }

    setContent() {
        this.setDefault();
        if (this.taxonomy) {
            this.newEid = this.taxonomy.id;
            this.newFolder = 'taxonomy';
            this.newOpaque = this.field ? getValueByPath(this.taxonomy, this.field) : this.taxonomy.cover;
            this.newAlt = this.alt || this.taxonomy.title;
            this.newUsecdn = this.cdn;
        } else if (this.cartItem) {
            this.newEid = this.cartItem.productid;
            this.newFolder = 'product';
            this.newOpaque = this.field ? getValueByPath(this.cartItem, this.field) : this.cartItem.img;
            this.newAlt = this.alt || this.cartItem.name;
            this.newUsecdn = this.cdn;
        } else if (this.product && !this.media) {
            this.newEid = this.product.id;
            this.newFolder = 'product';
            this.newOpaque = this.field ? getValueByPath(this.product, this.field) : this.product.cover;
            this.newAlt = this.alt || this.product.name;
            this.newUsecdn = this.cdn;
        } else if (this.product && this.media) {
            this.newEid = this.product.id;
            this.newFolder = 'product';
            this.newOpaque = this.media.attachopaqueid;
            this.newAlt = this.alt || this.media.caption;
            this.newUsecdn = this.cdn;
        }
        this.contentready = true;
    }

    setDefault() {
        this.newEid = this.eid;
        this.newFolder = this.folder;
        this.newOpaque = this.opaque;
        this.newAlt = this.alt;
        this.newUsecdn = this.usecdn;
        this.imageready = false;
    }

}